import { render, staticRenderFns } from "./modelManageDetail.vue?vue&type=template&id=3347f866&scoped=true&"
import script from "./modelManageDetail.vue?vue&type=script&lang=js&"
export * from "./modelManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347f866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3347f866')) {
      api.createRecord('3347f866', component.options)
    } else {
      api.reload('3347f866', component.options)
    }
    module.hot.accept("./modelManageDetail.vue?vue&type=template&id=3347f866&scoped=true&", function () {
      api.rerender('3347f866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/workflow/modelManage/modelManageDetail.vue"
export default component.exports